function isBrowser(): boolean {
  return ![typeof window, typeof document].includes('undefined');
}

export default isBrowser;
